var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex my-3"},_vm._l((_vm.dataCard),function(item,index){return _c('Card',{key:index,style:(index > 0 ? [{ 'margin-left': '10px' }] : ''),attrs:{"data":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }